export default __webpack_public_path__ + "static/media/Swift.21189152.png";